import { render, staticRenderFns } from "./KoliEklePopup.vue?vue&type=template&id=080aa3ae"
import script from "./KoliEklePopup.vue?vue&type=script&lang=js"
export * from "./KoliEklePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports